export default __webpack_public_path__ + "static/media/bundle-guide-us@2x.16e64ad7.jpg";